import RAF from '@/js/utils/raf'
import data from '@/mixins/data'
export default {
  name: 'webgl-header',
  mixins: [data],
  data () {
    return {
    }
  },
  props: {
    image: null,
    color: null,
    small: null
  },
  mounted () {
    RAF.suscribe('webgl-header', this.update.bind(this))

    let scene = this.$root.$children[0].headerScene
    this.scene = scene
    this.glColor = this.convertColor(this.color)

    if (this.small) {
      scene.container.classList.add('small')
    } else {
      scene.container.classList.remove('small')
    }

    if (this.image !== null) {
      scene.load('background', this.image)
    }

    if (this.glColor) {
      scene.loadColor(this.glColor)
    }

    this.initEvents()

    this.canvas = this.$refs['webgl-header-canvas']
    this.ctx = this.canvas.getContext('2d')
    this.resize()
    scene.onResize()

    this.observer = new IntersectionObserver(observables => {
      if (observables[0].intersectionRatio > 0.1) {
        this.paused = false
      } else {
        this.paused = true
      }
    }, {
      threshold: [0.1, 0.9]
    })
    this.observer.observe(this.$el)
  },

  beforeDestroy () {
    this.scene.reset()
    this.observer.unobserve(this.$el)
    RAF.unsuscribe('webgl-header')
  },

  methods: {
    initEvents () {
      this.$el.addEventListener('mousemove', (event) => {
        let scene = this.$root.$children[0].headerScene
        scene.cursorTarget[0] = event.clientX / ((scene.width / scene.dpr))
        scene.cursorTarget[1] = event.clientY / ((scene.height / scene.dpr))
      })
      window.addEventListener('resize', () => {
        this.resize()
      })
    },
    resize () {
      window.innerWidth < 2000 ? this.dpr = Math.min(window.devicePixelRatio, 2) : this.dpr = Math.min(window.devicePixelRatio, 1)
      this.width = this.$el.offsetWidth * this.dpr
      this.height = this.$el.offsetHeight * this.dpr
      this.canvas.width = this.width
      this.canvas.height = this.height
      this.canvas.style.maxWidth = this.$el.offsetWidth + 'px'
      this.canvas.style.maxHeight = this.$el.offsetHeight + 'px'
    },
    convertColor (hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? [
        parseInt(result[1], 16) / 255,
        parseInt(result[2], 16) / 255,
        parseInt(result[3], 16) / 255
      ] : null
    },
    update () {
      if (!this.paused) {
        let canvas = this.$root.$children[0].headerScene.canvas
        this.ctx.drawImage(canvas, 0, 0, this.width, this.height)
      }
    }
  }
}